const baseUrl = process.env.NODE_ENV === "production" ? "https://coursepage.com" : "https://dev.coursepage.com";
export default baseUrl;
